import api from './api';

class VerificationService {
  async getVerificationStatus() {
    try {
      const response = await api.get('/api/auth/verification');
      return response.data;
    } catch (error) {
      console.error('Error fetching verification status:', error);
      throw error;
    }
  }

  async verifyEmail() {
    try {
      const response = await api.post('/api/auth/verify-email');
      return response.data;
    } catch (error) {
      console.error('Error verifying email:', error);
      throw error;
    }
  }

  async updatePhone(phone) {
    try {
      const response = await api.post('/api/auth/update-phone', { phone });
      return response.data;
    } catch (error) {
      console.error('Error updating phone:', error);
      throw error;
    }
  }

  async verifyPhone(code) {
    try {
      const response = await api.post('/api/auth/verify-phone', { code });
      return response.data;
    } catch (error) {
      console.error('Error verifying phone:', error);
      throw error;
    }
  }

  async verifyId() {
    try {
      const response = await api.post('/api/auth/verify-id');
      return response.data;
    } catch (error) {
      console.error('Error verifying ID:', error);
      throw error;
    }
  }

  async getUserVerificationStatus(userId) {
    try {
      const response = await api.get(`/api/users/${userId}/verification`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user verification status:', error);
      throw error;
    }
  }
}

export const verificationService = new VerificationService(); 